module.exports = __webpack_public_path__ + "images/anwbautoverzekering1560f0c552057af392a7bb3c75255ca2.png";